import { render } from "./ProductSelection.vue?vue&type=template&id=13c0d644"
import script from "./ProductSelection.vue?vue&type=script&lang=js"
export * from "./ProductSelection.vue?vue&type=script&lang=js"

import "./ProductSelection.vue?vue&type=style&index=0&id=13c0d644&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__